import { useMutation, useQueryClient } from '@tanstack/react-query';
import { resourceApi } from '../api';
import { toast } from 'react-hot-toast';

export const useDeleteResource = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: resourceApi.deleteResource,
    onSuccess: () => {
      toast.success('Resource deleted successfully');
      // Invalidate queries to refresh data
      queryClient.invalidateQueries({ queryKey: ['resources'] });
      queryClient.invalidateQueries({ queryKey: ['resources-overview'] });
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to delete resource');
    },
  });
};
